import BlogPostSingle from './single-blog-post';

export default class BlogPostSingleDesktop extends BlogPostSingle {
    constructor(...args) {
        super(...args);

        console.log('Blog Post Single :: Desktop');
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// src/js/pages/single-blog-post/single-blog-post.desktop.js